import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import * as popupActions from './../../../actions/A_Popups';
import template from './../../../templates/PageLayout/Popups/ChooseEmailTemplatePopup.rt';

class chooseEmailBox extends PureComponent {
  render = template
}

function mapStateToProps(state) {
  const {chosenEmailTemplate} = state.popups;
  return {
    chosenEmailTemplate
  }
}

function mapDispatchToProps(dispatch) {
  return {
    handlePopupClose: () => dispatch(popupActions.showChooseEmailTemplatesPopup(false)),
    chooseEmailTemplate: (template) => dispatch(popupActions.chooseEmailTemplate(template))
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(chooseEmailBox);
